/**
 * FireFlyVnextHelpers.js
 *
 * Utility functions for sending analytics events to Firefly via EventAPI.
 *
 * Usage:
 * - Use `handleFireflySendEvent` to send general events.
 *   - `eventId` is optional. If provided, it will be included in the event payload.
 *   - All parameters are strictly checked; refer to the EventAPI documentation for required types.
 * - Use `handleFireflySendClickEvent` to send click events.
 *
 * For more details on EventAPI options and strict type requirements, see:
 * https://praxis-framework.prod.target.com/observability/analytics#eventapioptions
 *
 * All client info is derived from the current session and browser context.
 */

import { EventAPI } from '@praxis/analytics'
import apiConfig from 'apiConfig'

const fireflyConfig = {
  apiKey: apiConfig.analytics.apiKey,
  appName: 'PEGASUS',
  retries: 3,
  url: apiConfig.analytics.url,
}

const eventAPI = new EventAPI(fireflyConfig)

const getClientInfo = (session, pageName = '') => ({
  employee_login_id: session?.userInfo?.email || '',
  page_name: pageName,
  page_url: window.location.href,
  user_agent: navigator.userAgent,
  version: process.env.APP_VERSION,
})

export const handleFireflySendEvent = (
  eventType,
  pageName,
  taskName,
  session,
  eventId // optional
) => {
  const client = { ...getClientInfo(session, pageName) }
  eventAPI.sendEvent({
    client,
    event: {
      ...(eventId ? { id: eventId } : {}),
      type: eventType,
      value: taskName,
    },
  })
}

export const handleFireflySendClickEvent = (
  eventId,
  pageName,
  taskName,
  session
) => {
  const client = { ...getClientInfo(session, pageName) }
  eventAPI.sendClickEvent(eventId, {
    client,
    event: {
      id: eventId,
      value: taskName,
    },
  })
}
